import { render } from "./BaseHeaderMessage.vue?vue&type=template&id=eff1ce98&scoped=true"
import script from "./BaseHeaderMessage.vue?vue&type=script&lang=js"
export * from "./BaseHeaderMessage.vue?vue&type=script&lang=js"

import "./BaseHeaderMessage.vue?vue&type=style&index=0&id=eff1ce98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eff1ce98"]])

export default __exports__